import {
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
} from '@mui/x-data-grid-pro';

import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Close from '@mui/icons-material/Close';
import Search from '@mui/icons-material/Search';

type OwnerState = {
  expanded: boolean;
  hasValue: boolean;
};

const StyledQuickFilter = styled(QuickFilter)({
  display: 'grid',
  alignItems: 'center',
});

const StyledTextField = styled(TextField)<{ ownerState: OwnerState }>(
  ({ theme, ownerState }) => ({
    width: ownerState.expanded ? 300 : 'var(--trigger-width)',
    opacity: ownerState.expanded ? 1 : 0,
    transition: theme.transitions.create(['width', 'opacity']),
    backgroundColor: ownerState.hasValue
      ? 'transparent'
      : theme.palette.background.default,
    '& .MuiOutlinedInput-root': {
      backgroundColor: ownerState.hasValue
        ? 'transparent'
        : theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.text.secondary,
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.text.secondary,
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
      },
    },
    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
    borderRadius: 0.75,
  })
);

interface SharedToolbarQuickSearchFilterProps {
  placeholder?: string;
  debounceMs?: number;
}

export default function SharedToolbarQuickSearchFilter({
  placeholder,
  debounceMs,
}: SharedToolbarQuickSearchFilterProps) {
  return (
    <StyledQuickFilter debounceMs={debounceMs}>
      <QuickFilterControl
        render={({ ref, ...controlProps }, state) => (
          <StyledTextField
            {...controlProps}
            ownerState={{ expanded: true, hasValue: !!state.value }}
            inputRef={ref}
            aria-label="Search"
            placeholder={placeholder || 'Search...'}
            size="small"
            sx={{
              padding: '0px 0px 4px',
              height: '40px',
              marginRight: 1,
              '& .MuiInputBase-input': {
                marginLeft: '4px',
              },
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <Search
                    fontSize="small"
                    sx={{
                      ml: -0.5,
                      color: (theme) => theme.palette.text.secondary,
                    }}
                  />
                ),
                endAdornment: state.value ? (
                  <QuickFilterClear
                    edge="end"
                    size="small"
                    aria-label="Clear search"
                    material={{ sx: { marginRight: 0 } }}
                  >
                    <Close fontSize="small" />
                  </QuickFilterClear>
                ) : null,
                ...controlProps.slotProps?.input,
              },
              ...controlProps.slotProps,
            }}
          />
        )}
      />
    </StyledQuickFilter>
  );
}
